import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { RequisitionService } from '../services/requisition.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-contract-new',
  templateUrl: './list-contract-new.component.html',
  styleUrls: ['./list-contract-new.component.css']
})
export class ListContractNewComponent implements OnInit {

  listContract: any;
  loading: boolean;
  max: number;
  page: number;
  total: number;

  constructor(
    private dialog: MatDialog,
    private requisitionService: RequisitionService,
    private _router: Router
  ) {
    this.loading = false;
    this.max = 10;
  }

  ngOnInit() {
    this.refreshListing(1);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.refreshListing(1);
  }

  refreshListing(page) {
    this.loading = true;
    this.requisitionService.getContractNew(0, page)
    .subscribe(
      res => {
        this.loading = false;
        this.page = page;
        this.total = res.pagination.total;
        this.listContract = res.contracts;
      },
      () => {
        console.log('Error retrieving Contracts');
        this.loading = false;
      }
    );
  }

  gotoContract(contract) {
     console.log(contract.contract_id);
    this._router.navigate(['/viewcontract', contract.contract_id]);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/list-contract-new/list-contract-new.component.ts